import Vue from "vue";
import App from "./App";
import router from "./router/index";
import store from './store'
import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import firebase from 'firebase'

import 'native-toast/dist/native-toast.css'


import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
   
   if ( requiresAuth &&  !localStorage.getItem("authedUser")) {
      next('/')
  } 
  // else if (requiresAuth && localStorage.getItem("authedUser")) {
  //     next()
  // } 
  else {
     
      next()

  }
})

var firebaseConfig = {
  apiKey: "AIzaSyBRqflPolNjBcWiu--ocD2hqj11heYJ-rI",
  authDomain: "malta-2ad41.firebaseapp.com",
  databaseURL: "https://malta-2ad41.firebaseio.com",
  projectId: "malta-2ad41",
  storageBucket: "malta-2ad41.appspot.com",
  messagingSenderId: "68075691075",
  appId: "1:68075691075:web:7099d491d5ae78f41788f6",
  measurementId: "G-QEWZPJFWZ7"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
window.firebase = firebase;

Vue.use(PaperDashboard);
Vue.use(Antd);
Vue.use(BootstrapVue)

/* eslint-disable no-new */
new Vue({
  router,
  store,
  firebase,
  render: h => h(App)
}).$mount("#app");
